<template lang="pug">
  main
    el-row(type="flex", justify="center")
      el-col(:xs=18, :sm=18, :md=12)
        p(v-html="contents.intro")
        el-form(ref="form", :model="form", :rules="rules", label-position="top")

          el-form-item(:label="contents.repoSelectHint", prop="repo")
            el-select.block(v-model="form.repo", placeholder="")
              el-option(v-for="(repo, index) in contents.repos", :label="repo.name", :value="repo.name", :key="repo.github")

          el-form-item(:label="contents.issueTypesHint", prop="type")
            el-select.block(v-model="form.type", placeholder="")
              el-option(v-for="type in contents.issueTypes", :label="type", :value="type", :key="type")

          el-form-item(:label="contents.issueTitleHint", prop="title")
            el-input(v-model="form.title")

          template(v-if="isBug")
            el-form-item
              small
                p(v-text="contents.issueUsage")
                ul
                  li(v-for="l in contents.links[form.repo]", :key="l.link")
                    span(v-text="l.desc")
                    a(:href="l.link", v-text="l.link", target="_blank")
                b(v-text="contents.issueHint")

            el-form-item(:label="contents.versionRepositoryHint", prop="versionRepository")
              el-select.block(v-model="form.versionRepository", filterable, :loading="loading.repository", :no-match-text="contents.noMatchText", :no-data-text="contents.noDataText", placeholder="")
                el-option(v-for="tag in version.repo", :label="tag", :value="tag", :key="tag")

            el-form-item(:label="contents.versionBrowserHint", prop="versionBrowser")
              el-input(v-model="form.versionBrowser")

            el-form-item(:label="contents.versionVueHint", prop="versionVue")
              el-select.block(v-model="form.versionVue", filterable, :loading="loading.vue", :no-match-text="contents.noMatchText", :no-data-text="contents.noDataText", placeholder="")
                el-option(v-for="tag in versionVue", :label="tag", :value="tag", :key="tag")

            el-form-item(:label="contents.versionCesiumHint", prop="versionCesium")
              el-select.block(v-model="form.versionCesium", filterable, :loading="loading.vue", :no-match-text="contents.noMatchText", :no-data-text="contents.noDataText", placeholder="")
                el-option(v-for="tag in versionCesium", :label="tag", :value="tag", :key="tag")

            el-form-item(:label="contents.reproduceHint", prop="reproduce")
              el-input(v-model="form.reproduce")

            el-form-item
              small
                p(v-text="contents.reproduceHintSmall")
                ul
                  li(v-for="l in repo.reproduceLinks")
                    a(:href="l.link", v-text="l.name", target="_blank")

            el-form-item(:label="contents.stepsHint", prop="steps")
              el-input(type="textarea", v-model="form.steps", :autosize="{ minRows: 5, maxRows: 10 }")

            el-form-item
              small(v-html="contents.stepsHintSmall")

            el-form-item(:label="contents.expectHint", prop="expect")
              el-input(type="textarea", v-model="form.expect", :autosize="{ minRows: 5, maxRows: 10 }")

            el-form-item(:label="contents.actualHint", prop="actual")
              el-input(type="textarea", v-model="form.actual", :autosize="{ minRows: 5, maxRows: 10 }")

          template(v-else)
            el-form-item(:label="contents.existingComponentHint", prop="existingComponent")
              el-radio(v-model="form.existingComponent", :label="true") {{ contents.existingComponentYes }}
              el-radio(v-model="form.existingComponent", :label="false") {{ contents.existingComponentNo }}

            el-form-item(:label="contents.componentNameHint", prop="componentName")
              el-input(v-model="form.componentName")

            el-form-item(:label="contents.descHint", prop="desc")
              el-input(type="textarea", v-model="form.desc", :autosize="{ minRows: 5, maxRows: 10 }")


          el-form-item.center
            el-button(@click="preview", v-text="contents.preview", type="primary")


    el-dialog(:title="contents.dialog.title", v-model="show")
      div(v-html="issueHTML")
      span(slot="footer")
        el-button(type="primary", v-text="contents.dialog.button", @click="create")


</template>

<script>
  import contentLang from '../i18n/content'
  import axios from 'axios'
  import marked from 'marked'
  import hanabi from 'hanabi'

  const comment = '<!-- Created by issues bot. DO NOT REMOVE. -->'

  marked.setOptions({
    gfm: true,
    tables: true,
    breaks: false,
    pedantic: false,
    sanitize: true,
    smartLists: true,
    smartypants: false,
    highlight: code => hanabi(code)
  })

  export default {
    name: 'main-content',

    data () {
      const { repo } = this.$route.query
      let queryRepo = 'VueCesium'
      if (repo === 'element-plus') {
        queryRepo = 'VueCesium'
      }

      return {
        form: {
          repo: queryRepo,
          title: '',
          type: '',
          desc: '',
          versionRepository: '',
          versionVue: '',
          versionBrowser: '',
          versionCesium: '',
          reproduce: '',
          steps: '',
          expected: '',
          actual: '',
          existingComponent: true,
          componentName: ''
        },
        query: {
          repo: queryRepo
        },
        show: false,
        loading: {
          repository: false,
          vue: false
        },
        version: {
          repo: [],
          vue: [],
          cesium: []
        },
        issue: ''
      }
    },

    computed: {
      versionVue () {
        return this.version.vue
      },

      versionCesium () {
        return this.version.cesium
      },

      lang () {
        return this.$route.path.split('/')[1] || window.navigator.language
      },

      contents () {
        return contentLang.filter(c => c.lang === this.lang)[0]
      },

      api () {
        return {
          repositoryVersion: `https://data.jsdelivr.com/v1/package/npm/${this.repo && this.repo.npm}`,
          vueVersion: 'https://data.jsdelivr.com/v1/package/npm/vue',
          cesiumVersion: 'https://data.jsdelivr.com/v1/package/npm/cesium'
        }
      },

      isBug () {
        return !this.contents.issueTypes.indexOf(this.form.type)
      },

      rules () {
        const valid = this.contents.valid
        let rules = {}
        for (let prop in valid) {
          rules[prop] = [
            {
              required: true,
              trigger: 'change',
              message: valid[prop]
            }
          ]
        }

        rules['reproduce'].push({
          trigger: 'blur',
          validator: (rule, val, cb) => {
            if (this.repo.reproduceLinks.some(_ => _.link === val)) {
              cb({
                'zh-CN': '请填写正确的重现链接，不要直接复制示意链接',
                'en-US': 'Please provide correct link, do not copy the demo link directly'
              }[this.lang])
            } else if (/(github|jsfiddle|codepen|jsbin|codesandbox)/ig.test(val)) {
              cb()
            } else {
              cb({
                'zh-CN': '请填写正确的重现链接',
                'en-US': 'Please provide correct link'
              }[this.lang])
            }
          }
        })

        return rules
      },

      repo () {
        return this.contents.repos.filter(r => r.name === this.form.repo)[0]
      },

      issueHTML () {
        return marked(this.issue)
      },

      title () {
        const prefix = `[${this.isBug ? 'Bug Report' : 'Feature Request'}] `
        return encodeURIComponent(prefix + this.form.title).replace(/%2B/gi, '+')
      },

      body () {
        const issue = `
${comment}

${this.issue}

${comment}
`
        return encodeURIComponent(issue).replace(/%2B/gi, '+')
      }

    },

    watch: {
      lang: {
        handler () {
          this.$nextTick(() => {
            this.$refs.form.resetFields()
            this.form.repo = this.query.repo || this.contents.repos[0].name
            this.form.versionRepository = this.version.repo[0]
            this.form.versionVue = this.versionVue[0]
            this.form.type = this.contents.issueTypes[0]
          })
        },
        immediate: true
      },

      'form.repo': {
        handler () {
          this.fetchRepositoryVersion()
          this.form.versionVue = this.versionVue[0]
        },
        immediate: true
      },

      '$route.query': {
        handler (val) {

        },
        immediate: true
      }
    },

    methods: {
      preview () {
        this
          .$refs
          .form
          .validate(valid => {
            if (valid) {
              this.createIssue()
            }
          })
      },

      create () {
        window.open(`https://github.com/${this.repo.github}/issues/new?title=${this.title}&body=${this.body}`)
      },

      createIssue () {
        this.issue = this.isBug ? `
### ${this.form.repo} version
${this.form.versionRepository}

### OS/Browsers version
${this.form.versionBrowser}

### Vue version
${this.form.versionVue}

### Cesium version
${this.form.versionCesium}

### Reproduction Link
${this.form.reproduce}

### Steps to reproduce
${this.form.steps}

### What is Expected?
${this.form.expect}

### What is actually happening?
${this.form.actual}
`.trim() : `
### Existing Component
${this.form.existingComponent ? this.contents.existingComponentYes : this.contents.existingComponentNo}

### Component Name
${this.form.componentName}

### Description
${this.form.desc}
`.trim()
        this.show = true
      },

      async fetchRepositoryVersion () {
        const response = await axios.get(this.api.repositoryVersion)
        // remove deprecated versions
        this.version.repo = response.data.versions.filter(_ => ['1.0.2-beta.12'].indexOf(_) < 0)
        this.form.versionRepository = this.version.repo[0]
      },

      async fetchVueVersion () {
        const response = await axios.get(this.api.vueVersion)
        this.version.vue = response.data.versions
        this.form.versionVue = this.versionVue[0]
      },

      async fetchCesiumVersion () {
        const response = await axios.get(this.api.cesiumVersion)
        this.version.cesium = response.data.versions
        this.form.versionCesium = this.versionCesium[0]
      }
    },

    mounted () {
      this.fetchVueVersion()
      this.fetchCesiumVersion()
    }
  }
</script>

<style lang="stylus">
  .el-select.block
    display block
  main
    padding-top 20px
  small
    font-size 14px
    code
      background-color: #d93f0b;
      display: inline-block;
      padding: .25em .4em;
      font-weight: 700;
      line-height: 1.2em;
      color: #fff;
      text-align: center;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: .25rem;
      margin 0 5px
  .el-form-item
    &.center
      text-align center
    label
      font-size 18px
  li
    a
      word-wrap break-word
</style>



// WEBPACK FOOTER //
// content.vue?c1042100